import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Stack,
  Text,
} from '@chakra-ui/react';
import { Button } from '@components/forms';
import { useMutation } from '@apollo/client';
import { DELETE_UPDATE } from '@queries/V2moms';
import { useV2momContext } from '@contexts/V2momProvider';
import { useNotifier } from '@utils/Notify';


const DeleteUpdateModal = ({modalDisclosure, update}) => {
  const { serverError } = useNotifier();
  const { dispatch } = useV2momContext();

  const [deleteUpdate, { loading }] = useMutation(DELETE_UPDATE,{
    onCompleted: (data) => {
      dispatch({ type: 'DELETE_UPDATE', payload: { update: data.deleteUpdate.update } })
      modalDisclosure.onClose();
    },
    onError: (error) => {
      serverError(error.message)
    },
  });
  
  const handleDelete = () => {
    deleteUpdate({ variables: {
      id: update.id,
    }});
  }

  if (loading) return <p>Loading ...</p>;

  return (
    <Modal isOpen={modalDisclosure.isOpen} onClose={modalDisclosure.onClose} size='lg' motionPreset='slideInBottom' isCentered>
      <ModalOverlay />
      <ModalContent borderRadius='sm'>
        <ModalHeader>
          Delete update
        </ModalHeader>
        <ModalBody>
          Are you sure you want to delete this update? Deleting this update will reset the status to the previous update.
          <Text pt={4} fontWeight='bold'>This action cannot be undone.</Text>
          <Stack direction='row' spacing={2} my={4} justifyContent='right'>
            <Button variant='ghost' onClick={modalDisclosure.onClose}>Close</Button>
            <Button variant='dangerOutline' onClick={handleDelete}>Delete</Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default DeleteUpdateModal;